import { appSettingsService } from "@/services/appsettings-api.service";

const SET_CLAIM_PAYMENTS_ENABLED = 'setClaimPaymentsEnabled'
const SET_RUN_PIPELINES_ENABLED = 'setRunPipelinesEnabled'

const state = () => ({
    claimPaymentsEnabled: false,
    runPipelinesEnabled: false
});

const getters = {
    claimPaymentsEnabled: state => state.claimPaymentsEnabled,
    runPipelinesEnabled: state => state.runPipelinesEnabled
};

const mutations = {
    [SET_CLAIM_PAYMENTS_ENABLED](state, payload) {
        state.claimPaymentsEnabled = payload
    },
    [SET_RUN_PIPELINES_ENABLED](state, payload) {
        state.runPipelinesEnabled = payload
    }
};

const actions = {
    fetchClaimPaymentsEnabled({ commit }, payload) {
        return new Promise((resolve, reject) => {
            appSettingsService
                .getClaimPaymentsEnabled()
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            commit(SET_CLAIM_PAYMENTS_ENABLED, apiResponse)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    fetchRunPipelinesEnabled({ commit }, payload) {
        return new Promise((resolve, reject) => {
            appSettingsService
                .getRunPipelinesEnabled()
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            commit(SET_RUN_PIPELINES_ENABLED, apiResponse)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}